import { Component, Input } from '@angular/core';

import { environment } from '../../../environments/environment';
import { FileRecordDto } from '@careapp-group/ng-sdk-v2-new';

@Component({
  selector: 'ca-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss'],
})
export class ProfileImageComponent {
  photo: string;

  private version = environment.API_VERSION;
  private url = environment.API_BASE_URL;

  @Input()
  set id(value: string) {
    if (value) {
      this.photo = `${this.url}/${this.version}/files/${value}/download`;
    } else {
      this.photo = undefined;
    }
  }

  @Input()
  set file(image: FileRecordDto) {
    if (image) {
      this.photo = `${this.url}/${this.version}/files/${image.id}/download`;
    } else {
      this.photo = undefined;
    }
  }
}
